/* eslint-disable jsx-a11y/anchor-is-valid */
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import RecipeContent from '../RecipeContent';
import Rating from '../../../widgets/Rating/Rating';
import { NS_RECIPE } from '../../../utils/lang';

export default function RateRecipeSummary({ recipe }) {
	const { t } = useTranslation(NS_RECIPE);

	// return this Bad Boy because we only want recipes
	if (recipe?.__typename === 'Post') return (null);

	const recipeContent = new RecipeContent(recipe);

	const cta = recipeContent.getNumVotes() === 0 ? t('rateRecipeFirst') : t('rateRecipe');

	const votes = recipeContent.getNumVotes() > 0 ? (
		<span className="total-votes">
			(
			{recipeContent.getNumVotes()}
			{t('ratings')}
			)
		</span>
	) : null;

	const scrollToBottomRecipeRating = (event) => {
		event.preventDefault();
		document.querySelector('#rate-recipe-anchor').scrollIntoView({
			behavior: 'smooth',
		});
	};

	return (
		<>
			<div className="rate-recipe-summary">
				<Rating rating={recipeContent.getAverageRating().toFixed(2)} />
				<div className="rating-score">
					{votes}
				</div>
			</div>
			<div className="rating-cta">
				<a
					href="#"
					onClick={scrollToBottomRecipeRating}
				>
					<span>{cta}</span>
					<span className="arrow-down">&#9662;</span>
				</a>
			</div>
		</>
	);
}

RateRecipeSummary.propTypes = {
	recipe: PropTypes.object.isRequired,
};
